import axiosInstance from '../services/AxiosInstance';

export function getRoles(pageNum = 1, pageSize = 10, searchTerm = "", filterQuery = "") {
    return axiosInstance.get(`role?populate=policies&pageNum=${pageNum}&pageSize=${pageSize}&search=${searchTerm}&${filterQuery}`);
}

export function getAllRoles(pageNum = 1, pageSize = 10) {
    return axiosInstance.get(`role/all`);
}

export function deleteRole(roleId) {
    return axiosInstance.delete(`role/${roleId}`);
}

export function createRole(roleData) {
    return axiosInstance.post(`role`,roleData);
}

export function updateRole(roleId, roleData) {
    return axiosInstance.put(`role/${roleId}`,roleData);
}
